import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { Link, useNavigate } from 'react-router-dom'
import total_hour from '../images/totalhours.png'
import today_hour from "../images/todaywork.png"
import active_member  from "../images/members.png"
import completed from "../images/completed.png"
import pending from "../images/pending.png"
import activetask from "../images/activetask.png"


export default function Worklog_summery() {
  const navigate = useNavigate();
  const [totalMonthHours, setTotalMonthHours] = useState('0h');
  const [todayHours, setTodayHours] = useState('0h');
  const [activeMembers, setActiveMembers] = useState(0);

  const [pendingTasks, setPendingTasks] = useState(0);
  const [completedTasks, setCompletedTasks] = useState(0);
  const [activeTasks, setActiveTasks] = useState(0);

  const [pendingTaskList, setPendingTaskList] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [membretype, setMembertype] = useState(false);
  useEffect(() => {
     let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
    let com_id = localStorage.getItem('mem_company_id');
    loadTimeTrackingData(com_id);
    loadTaskData(com_id);
  })

  async function loadTimeTrackingData(com_id) {
    try {
      const response = await fetch('getTimeTrackingSummary.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          company_id: com_id
        })
      });
      const data = await response.json();
      let totalMonthSeconds = 0;
      let todaySeconds = 0;
      let uniqueMembers = new Set();
      const today = new Date().toISOString().split('T')[0];
      const currentMonth = new Date().getMonth();
      const currentYear = new Date().getFullYear();
      data.forEach(item => {
        const workDate = new Date(item.dateofWork);
        const workMonth = workDate.getMonth();
        const workYear = workDate.getFullYear();
        // CURRENT MONTH
        if (
          workMonth === currentMonth &&
          workYear === currentYear
        ) {
          totalMonthSeconds += convertTimeToSeconds(item.time_worked);
        }
        // TODAY
        if (item.dateofWork === today) {
          todaySeconds += convertTimeToSeconds(item.time_worked);
          uniqueMembers.add(item.user_id);
        }
      });
      setTotalMonthHours(formatSeconds(totalMonthSeconds));
      setTodayHours(formatSeconds(todaySeconds));
      setActiveMembers(uniqueMembers.size);
    } catch (error) {
      console.log(error);
    }
  }

  async function loadTaskData(com_id) {
    try {
      const response = await fetch('getTaskSummary.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          company_id: com_id
        })
      });
      const data = await response.json();
      let pending = 0;
      let completed = 0;
      let active = 0;
      const currentMonth = new Date().getMonth();
      const currentYear = new Date().getFullYear();
      data.forEach(item => {
        const assignDate = new Date(item.assigneDate);
        const taskMonth = assignDate.getMonth();
        const taskYear = assignDate.getFullYear();
        
          if (item.tsk_status === 'pending') {
            pending++;
          }
          if (item.tsk_status === 'complete') {
            completed++;
          }
          if (item.tsk_status === 'active') {
            active++;
          }
        
      });

      setPendingTasks(pending);
      setCompletedTasks(completed);
      setActiveTasks(active);

    } catch (error) {

      console.log(error);

    }

  }

  function convertTimeToSeconds(time) {
    const parts = time.split(':');
    const hours = parseInt(parts[0]) || 0;
    const minutes = parseInt(parts[1]) || 0;
    const seconds = parseInt(parts[2]) || 0;
    return (hours * 3600) + (minutes * 60) + seconds;
  }

  function formatSeconds(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    return `${hours}h ${minutes}m`;
  }

  async function showpendingtasklist() {
    try {
      let com_id = localStorage.getItem('mem_company_id');
      const response = await fetch('getPendingTaskList.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          company_id: com_id
        })
      });
      const data = await response.json();
      setPendingTaskList(data);
      setShowPopup(true);
    } catch (error) {
      console.log(error);
    }

  }

  function closePopup() {
    setShowPopup(false);
  }

  function viewTaskDetails(id, proj_id) {
    localStorage.setItem('taskid', id);
    localStorage.setItem('taskproid', proj_id);
    navigate('/task_details');
  }


  return (
    <div>
      <div className='fullwidth pb-30 pull_left'>
        <h3>Summery</h3>
      </div> 
      <div className='vl_listing_row'>
        <div className='resource_card'>
          <div className='resource_inner'>
            <div className='card_imgholder'>
              <img src={total_hour} alt="Total hour" />
            </div>
            <h3>Total Logged Hours</h3>
            <span>Total hours worked this month</span>
            <p>{totalMonthHours}</p>
          </div>
        </div>
        <div className='resource_card'>
          <div className='resource_inner'>
            <div className='card_imgholder'>
              <img src={today_hour} alt="Total hour" />
            </div>
            <h3>Today's Worke</h3>
            <span>Total hours worked today</span>
            <p>{todayHours}</p>
          </div>
        </div>
      </div>
      <div className='vl_listing_row'>
        <div className='resource_card'>
          <div className='resource_inner'>
            <div className='card_imgholder'>
              <img src={active_member} alt="Total hour" />
            </div>
            <h3>Active Members</h3>
            <span>Member's who worked today</span>
            <p>{activeMembers} Members</p>
          </div>
        </div>
        <div className='resource_card'>
          <div className='resource_inner'>
            <div className='card_imgholder'>
              <img src={completed} alt="Total hour" />
            </div>
            <h3>Completed Tasks</h3>
            <span>Task completed this month</span>
            <p>{completedTasks}</p>
          </div>
        </div>
      </div>
      <div className='vl_listing_row'>
        <div className='resource_card'>
          <div className='resource_inner'>
            <div className='card_imgholder'>
              <img src={pending} alt="Total hour" />
            </div>
            <h3>Pending Tasks</h3>
            <span>Total Number of pending tasks: </span>
            <span>{pendingTasks}</span>
            <div className='small_buttonholder'>
              <button onClick={showpendingtasklist}>
                View
              </button>
            </div>
          </div>
        </div>
        <div className='resource_card'>
          <div className='resource_inner'>
            <div className='card_imgholder'>
              <img src={activetask} alt="Total hour" />
            </div>
            <h3>Active Tasks</h3>
            <span>Total Active task this month</span>
            <p>{activeTasks}</p>
          </div>
        </div>
      </div>
      {
        showPopup && (
          <div className='vl_popup_overlay'>
            <div className='vl_popup_box'>
              <div className='vl_popup_header'>
                <h2>Pending Task List</h2>
                <button
                  className='vl_close_btn'
                  onClick={closePopup}
                >
                  ×
                </button>
              </div>
              <div className='vl_popup_body'>
                {
                  pendingTaskList.length > 0 ? (
                    <table className='vl_task_table'>
                      <thead>
                        <tr>
                          <th>Task Name</th>
                          <th>Status</th>
                          <th>Assigned Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          pendingTaskList.map((item, index) => (
                            <tr key={index}>
                              <td>{item.taskname}</td>
                              <td>
                                <span className='pending_badge'>
                                  {item.tsk_status}
                                </span>
                              </td>
                              <td>{item.assigneDate}</td>
                              <td>
                                <button
                                  className='view_btn'
                                  onClick={() =>
                                    viewTaskDetails(
                                      item.id,
                                      item.proj_id
                                    )
                                  }
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  ) : (
                    <div className='vl_empty_state'>
                      No pending task found
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        )
      }
      {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                         <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
    </div>
  )
}
